import { BoxStyleProps } from "@twilio-paste/core/box";
import { TextStyleProps } from "@twilio-paste/core/text";

export const formStyles: BoxStyleProps = {
    padding: "space40",
    paddingTop: "space80",
    overflow: "auto"
};

export const introStyles: TextStyleProps  & { style?: React.CSSProperties }  = {
    style:{fontSize:"fontSize50"},
    marginBottom: "space70"
};
export const disclaimerStyles: TextStyleProps  = {
    fontSize:"fontSize20",
    marginBottom: "space40"
};

export const fieldStyles: BoxStyleProps = {
    marginBottom: "space70"
};
